import { render } from "./SheetMotion.vue?vue&type=template&id=dc7a45f0"
import script from "./SheetMotion.vue?vue&type=script&lang=ts"
export * from "./SheetMotion.vue?vue&type=script&lang=ts"

import "./SheetMotion.vue?vue&type=style&index=0&id=dc7a45f0&lang=scss"
script.render = render

export default script